export const AGE_ANSWER_ADD = 'AGE_ANSWER_ADD';
